/*
 *		Copyright (c) 2011-2019 Acronis Incorporated. All rights reserved.
 *
 *	This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *	No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

'use strict';

angular.module('access.Nodes')
    .directive('accNodeNotarizationIndicator', ['template', function(template) {
        return {
            scope: {
                notarization: '=accNodeNotarizationIndicator',
                isPreviousRevisionNotarization: '='
            },
            templateUrl: template('nodes/_node_notarization_indicator')
        }
    }]);
